import { StatusBar, View, Text, Pressable, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import * as Location from 'expo-location';

import {
  updateData,
  updateDataImage,
} from "../../../../services/Profile/profileService";
import styles from "../../styles/profileStyle";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import { Colors } from "../../../../globalStyles/ColorConfig";
import RadioView from "../../components/RadioView";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import { PROFILE_ROUTES } from "../../../../navigation/routes";

const ViewComponent = ({
  title,
  icon,
  isSelected,
  onSelectView,
}: {
  title?: any;
  icon?: any;
  isSelected?: any;
  onSelectView?: any;
}) => {
  return (
    <View
      style={{
        overflow: "hidden",
        marginBottom: 10,
        backgroundColor: isSelected ? "#FFF" : "#f8f8f8",
        borderRadius: 12,
        borderWidth: 2,
        borderColor: isSelected ? Colors.gold10 : "transparent",
      }}
    >
      <Pressable
        onPress={() => onSelectView(title)}
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 16,
          alignItems: "center",
        }}
        android_ripple={{ color: "#f8f8f8", borderless: false }}
      >
        <Text>{icon}</Text>
        <Text
          style={[
            GlobalStyles.bodyText,
            {
              color: Colors.black50,
              width: "85%",
              fontFamily: "InterMedium",
              letterSpacing: -0.3,
              fontSize: 16,
            },
          ]}
          numberOfLines={2}
        >
          {title}
        </Text>
      </Pressable>
    </View>
  );
};

const UseReason = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [reason, setReason] = useState<string | null>(null);

  const handleNextButton = async () => {
    const { granted }  = await Location.getForegroundPermissionsAsync();
    const updateUser = {
      reasonForUsingSpark: reason,
    };
    await updateDataImage(updateUser);
    await updateData({ steps: 9 });
    if (reason == "Explore curated experiences and discover new people" ) {
      navigation.navigate(PROFILE_ROUTES.DATE_PREFERENCE as never);
    }else {
      navigation.navigate(granted ? PROFILE_ROUTES.ONBOARD_ALLDONE as never : PROFILE_ROUTES.ONBOARD_GRANTACCESS as never);
    }
  };

  const handleSkip = async () => {
    const { granted }  = await Location.getForegroundPermissionsAsync();
    navigation.navigate(granted ? PROFILE_ROUTES.ONBOARD_ALLDONE as never : PROFILE_ROUTES.ONBOARD_GRANTACCESS as never);
  }

  const validateName = () => {
    if (!reason) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 25,
          gap: 16,
        }}
      >
      

        <View style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
          <View style={{ width: '18%', backgroundColor: 'black' }}></View>
          <View style={{ width: '50%' }}>
            <TopIconView
              icon={<OnBoardingIcons.LoveIcon />}
              currentScreen={9}
              totalScreens={10}
            />
          </View>
          <TouchableOpacity onPress={handleSkip}><Text style={{ color: '#C0A46F', textDecorationLine: 'underline', fontSize: 15 }}>Skip</Text></TouchableOpacity>
        </View>
        <View style={[styles.middleScreen, { gap: 10 }]}>
          <TextView
            title="What would you like to use Spark for?"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 37,
                letterSpacing: -0.4,
                marginBottom: 10,
              },
            ]}
          />
          <RadioView select={setReason}>
            <ViewComponent
              title="Explore curated experiences and discover new people"
              icon={<OnBoardingIcons.DiamondIconv2 />}
            />
            <ViewComponent
              title="Explore curated experiences with partner"
              icon={<OnBoardingIcons.DiamondIcon />}
            />
          </RadioView>
        </View>
      </View>

      <BottomView
        enableTitle={true}
        onPress={handleNextButton}
        disableBtn={validateName()}
        bottomTitle="This helps our engine to understand you better"
        style={{ paddingBottom: 20 }}
      />
    </SafeAreaView>
  );
};

export default UseReason;
